import { makeStyles } from '@mui/styles';

export default makeStyles((theme) => ({
	gradientNavBarHeading: {
		background: 'linear-gradient(45deg, #00bcd4, #e91e63, #00bcd4, #e91e63)',
		backgroundSize: '400% 400%',
		animation: '$gradientAnimation 35s ease infinite',
		WebkitBackgroundClip: 'text',
		color: 'transparent',
		flexGrow: 0.2,
		cursor: 'pointer',
		boxShadow: 'unset',
		textAlign: 'center',
		display: 'flex',
		alignItems: 'center',
		fontWeight: 'bold !important'
	},
	'@keyframes gradientAnimation': {
		'0%': {
			backgroundPosition: '0% 50%'
		},
		'50%': {
			backgroundPosition: '100% 50%'
		},
		'100%': {
			backgroundPosition: '0% 50%'
		}
	},
	anchorStyles: {
		'&>div': {
			padding: '1rem'
		},
		'&>div:first-child': {
			fontWeight: 'bold',
			fontSize: '2.3rem'
		}
	}
}));
